import { render, staticRenderFns } from "./FeedbackContentList.vue?vue&type=template&id=00a62ae4&scoped=true&"
import script from "./FeedbackContentList.vue?vue&type=script&lang=js&"
export * from "./FeedbackContentList.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackContentList.vue?vue&type=style&index=0&id=00a62ae4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a62ae4",
  null
  
)

export default component.exports